import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const autoAssignDefaultsQueryKey = () => ['auto-assign-workers-defaults'];

export const useAutoAssignDefaults = () => {
  const api = useAPI();

  return useQuery({
    queryKey: autoAssignDefaultsQueryKey(),
    queryFn: () => api.getBackProductionLotAutoAssignWorkersDefaults(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
